// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/fonts/sofia-sans/SofiaSans-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/fonts/sofia-sans/SofiaSans-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/fonts/sofia-sans/SofiaSans-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/assets/fonts/sofia-sans/SofiaSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/assets/fonts/sofia-sans/SofiaSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/assets/fonts/sofia-sans/SofiaSans-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/src/assets/fonts/sofia-sans/SofiaSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/src/assets/fonts/sofia-sans/SofiaSans-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/src/assets/fonts/sofia-sans/SofiaSans-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Sofia Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: 'Sofia Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 200;
  font-style: normal;
}

@font-face {
  font-family: 'Sofia Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'Sofia Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Sofia Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Sofia Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Sofia Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'Sofia Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: 'Sofia Sans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('truetype');
  font-weight: 900;
  font-style: normal;
}

body {
  font-size: 16px;
  /* 16px */
}

@media (max-width: 1980px) {
  html {
    font-size: 16px;
  }
}

@media (max-width: 1680px) {
  html {
    font-size: 14px;
  }
}

@media (max-width: 1480px) {
  html {
    font-size: 13px;
  }
}

@media (max-width: 992px) {
  html {
    font-size: 13px;
  }
}

/* @media (max-width: 768px) {
  html {
    font-size: 12px;   
  }
} */

/* @media (max-width: 576px) {
  html {
    font-size: 11px;
  }
} */


/* this media query is used for existing app in this media query set font size according to my screen */
@media (max-width: 1450px) {
  .text-50 {
    font-size: 35px;
  }

  .text-35 {
    font-size: 24px;
  }

  .text-33 {
    font-size: 23px;
  }

  .text-30 {
    font-size: 22px;
  }

  .text-28 {
    font-size: 21px;
  }

  .text-25 {
    font-size: 19px;
  }

  .text-24 {
    font-size: 18px;
  }

  .text-22 {
    font-size: 16px;
  }

  .text-21 {
    font-size: 15px;
  }

  .text-20 {
    font-size: 14px;
  }

  .text-19 {
    font-size: 13px;
  }

  .text-18 {
    font-size: 12px;
  }

  .text-17 {
    font-size: 12px;
  }

  .text-16 {
    font-size: 12px;
  }

  .text-15 {
    font-size: 10px;
  }

  .text-14 {
    font-size: 9.5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,+DAA8E;EAC9E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAAoF;EACpF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAA+E;EAC/E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAAiF;EACjF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAAgF;EAChF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAAkF;EAClF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAA8E;EAC9E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAAmF;EACnF,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+DAA+E;EAC/E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;;GAIG;;AAEH;;;;GAIG;;;AAGH,uGAAuG;AACvG;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@font-face {\n  font-family: 'Sofia Sans';\n  src: url('/src/assets/fonts/sofia-sans/SofiaSans-Thin.ttf') format('truetype');\n  font-weight: 100;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Sofia Sans';\n  src: url('/src/assets/fonts/sofia-sans/SofiaSans-ExtraLight.ttf') format('truetype');\n  font-weight: 200;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Sofia Sans';\n  src: url('/src/assets/fonts/sofia-sans/SofiaSans-Light.ttf') format('truetype');\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Sofia Sans';\n  src: url('/src/assets/fonts/sofia-sans/SofiaSans-Regular.ttf') format('truetype');\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Sofia Sans';\n  src: url('/src/assets/fonts/sofia-sans/SofiaSans-Medium.ttf') format('truetype');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Sofia Sans';\n  src: url('/src/assets/fonts/sofia-sans/SofiaSans-SemiBold.ttf') format('truetype');\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Sofia Sans';\n  src: url('/src/assets/fonts/sofia-sans/SofiaSans-Bold.ttf') format('truetype');\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Sofia Sans';\n  src: url('/src/assets/fonts/sofia-sans/SofiaSans-ExtraBold.ttf') format('truetype');\n  font-weight: 800;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Sofia Sans';\n  src: url('/src/assets/fonts/sofia-sans/SofiaSans-Black.ttf') format('truetype');\n  font-weight: 900;\n  font-style: normal;\n}\n\nbody {\n  font-size: 16px;\n  /* 16px */\n}\n\n@media (max-width: 1980px) {\n  html {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 1680px) {\n  html {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 1480px) {\n  html {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 992px) {\n  html {\n    font-size: 13px;\n  }\n}\n\n/* @media (max-width: 768px) {\n  html {\n    font-size: 12px;   \n  }\n} */\n\n/* @media (max-width: 576px) {\n  html {\n    font-size: 11px;\n  }\n} */\n\n\n/* this media query is used for existing app in this media query set font size according to my screen */\n@media (max-width: 1450px) {\n  .text-50 {\n    font-size: 35px;\n  }\n\n  .text-35 {\n    font-size: 24px;\n  }\n\n  .text-33 {\n    font-size: 23px;\n  }\n\n  .text-30 {\n    font-size: 22px;\n  }\n\n  .text-28 {\n    font-size: 21px;\n  }\n\n  .text-25 {\n    font-size: 19px;\n  }\n\n  .text-24 {\n    font-size: 18px;\n  }\n\n  .text-22 {\n    font-size: 16px;\n  }\n\n  .text-21 {\n    font-size: 15px;\n  }\n\n  .text-20 {\n    font-size: 14px;\n  }\n\n  .text-19 {\n    font-size: 13px;\n  }\n\n  .text-18 {\n    font-size: 12px;\n  }\n\n  .text-17 {\n    font-size: 12px;\n  }\n\n  .text-16 {\n    font-size: 12px;\n  }\n\n  .text-15 {\n    font-size: 10px;\n  }\n\n  .text-14 {\n    font-size: 9.5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
